import { IS_DEBUG } from '@/client/confs/app';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export const AppTitle = memo(() => {
  const { t } = useTranslation();

  return (
    <a href="/" aria-label="SakerX" className="flex items-center gap-2 whitespace-nowrap">
      {/* Mark (blue gradient triangle, works on both themes) + theme-aware wordmark.
         The old horizontal PNG baked the "PROTOCOL" subtext in a light color, so it
         vanished on the light theme; render it as text so it adapts per theme. */}
      {/* max-w-none: the CSS reset's img { max-width: 100% } lets flex crush the
         logo to 0 when the header row is tight (the wordmark then slides under the
         nav/token filter). Opting out makes this anchor's min width honest, so the
         row lays out around the full mark instead of overlapping it. */}
      <img src="/img/saker-logo-icon.png" alt="" className="h-7 w-auto lg:h-8 shrink-0 max-w-none" />
      {/* Wordmark column collapses to the mark alone below sm: at 375px the header
         (brand + token filter + sign-in) is wider than the viewport with any text
         next to the mark, and the overflow slides under the filter container. */}
      <span className="hidden sm:flex flex-col leading-[1.05]">
        <span className="flex items-baseline gap-1">
          <span className="font-display font-bold text-lg lg:text-xl text-brand-primary">SakerX</span>
          {/* Debug-build marker. It lives inside the wordmark column because the
             header left group has zero horizontal slack at every viewport (the old
             trailing badge collided with the nav/token filter); the letter-spaced
             PROTOCOL subline is wider than "SakerX" + chip, so this adds no width. */}
          {IS_DEBUG && (
            <span className="text-[9px] font-medium uppercase tracking-wide text-foreground/50">Dev</span>
          )}
        </span>
        {/* Letter-spaced subline is the widest line of the wordmark, so it sets
           the column width the Dev chip fits inside. */}
        <span className="text-[9px] font-medium uppercase tracking-[0.18em] text-muted-foreground">Predict</span>
      </span>
      <h1 className="hidden">{t('title')}</h1>
    </a>
  );
});

AppTitle.displayName = 'AppTitle';
